import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import SelectPretty from 'components/Input/SelectPretty'

const reasonOptions = [
  {
    name: 'Not in Service',
    value: 'rejected',
  },
  {
    name: 'Line Busy',
    value: 'busy',
  },
]

export default class RejectForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Reject an incoming call. Use this to block unwanted calls. You will not be charged for the
          call it is the very first 'Action' node after the flow is triggered.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          name="reason"
          options={reasonOptions}
          component={SelectPretty}
          label="Rejection tone"
          validate={[vRequired]}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Reject/RejectForm.jsx